
import * as React from "react";
import Page from "../../../shared/components/Page";
import { styled } from '@mui/material/styles';
import { capitalCase, sentenceCase } from 'change-case';
import call from "src/core/services/http";
import { useEffect, useState } from "react";
import { Backdrop, Box, Button, Card, CardContent, CardHeader, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Slide, Stack, Tab, Tabs, TextField } from "@mui/material";
import Iconify from "src/shared/components/Iconify";
import useTabs from "src/shared/hooks/useTabs";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import AwaitingApproval from "../components/awaitingApproval";
import Disbursed from "../components/disbursed";
import Ready from "../components/readyForDisbursemnt";
import { filter } from "lodash";

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const customStyles = {
    indicator: {
        marginBottom: -4, // Adjust this value to reduce the space
    },
};
const TabsWrapperStyle = styled('div')(({ theme }) => ({
    zIndex: 9,
    bottom: 0,
    width: '100%',
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
        justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
        paddingRight: theme.spacing(3),
    },
}));

const defaultState = {
    "recipient_account_number": "",
    "amount": "",
    "description": "",
    "external_account_reference": "",
    "external_account_name": "",
    "payer_mobile_number": "",
    "payer_id_number": ""
}

export default function KTDAProcessing() {

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        severity: 'success',
        message: ''
    });

    const { open } = state;

    const { currentTab, onChangeTab } = useTabs('Ready For Disbursement');
    const [injectable, setInjectable] = useState(<>No preview available</>)
    const [uiName,setUiName] = useState('')

    const injectUI = ({ name, UIUX }) => {
        const uiComponent = {
            value: name,
            icon: <Iconify icon={'akar-icons:people-group'} width={20} height={20} />,
            component: UIUX,
            injected: true
        }
        setUiName(name)
    
        const hasIt = filter(TABS, predicate => predicate.value === name)
        // if (hasIt.length > 0) {
        //     return onChangeTab(null, name)
        // }
        // let tabs = TABS
        // tabs.push(uiComponent)
        // setTabs(tabs)
    
        setInjectable(UIUX)
        setState({ ...state, open: true })
        // onChangeTab(null, name)
    }

    const [TABS, setTabs] = useState([
        // {
        //     value: 'awaiting_approval',
        //     icon: <Iconify icon={'ci:link-break'} width={20} height={20} />,
        //     component: <AwaitingApproval injectUI={injectUI} />,
        //     injected: false
        // },
        {
            value: 'Ready For Disbursement',
            icon: <Iconify icon={'ci:cookie'} width={20} height={20} />,
            component: <Ready injectUI={injectUI} />,
            injected: false
        },
        {
            value: 'Disbursed',
            icon: <Iconify icon={'ci:folder-check'} width={20} height={20} />,
            component: <Disbursed injectUI={injectUI} />,
            injected: false
        }
    ])

    useEffect(() => {
    }, [currentTab])

    const [payload, setPayload] = useState(defaultState)

    const onFieldChange = (e) => {
        setPayload({ ...payload, [e.target.name]: e.target.value });
    };

    const [submitting, setSubmitting] = useState(false)

    const addOrder = async () => {
        setSubmitting(true)
        payload.sender_account_number = ''//shop.account_number
        const request = await call('post', `/money-order/`, payload)

        if (request.data.status) {
            setPayload(defaultState)

            toast.success(request.data.message)
        } else {
            toast.error(request.data.message)
        }
        setSubmitting(false)
    }



    const changeTab = (e, value) => {
        // const tabs = TABS
        // if (!["awaiting_approval", "ready", "disbursed"].includes(value)) {
        //     tabs.pop()
        // }
        // setTabs(tabs)
        onChangeTab(e, value)

    }


    return (
        <Page title="Wage Disbursement">
            <Backdrop open={open} >
                <Dialog open={open} maxWidth='xl'  TransitionComponent={Transition} fullWidth>
                    <DialogTitle  title={uiName} />
                    <DialogContent >
                        {injectable}
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={() => setState({ ...state, open: !open })} color="error">Close</Button>
                        {/* <LoadingButton variant="contained" loading={submitting} onClick={addOrder} color="primary">Submit</LoadingButton> */}
                    </DialogActions>
                </Dialog>
            </Backdrop>

            <Card>
                <CardHeader title='Wage Disbursement' subheader={sentenceCase(currentTab)} />
                {/* action={<Button variant="contained" onClick={() => setState({ ...state, open: !open })} size="small">+ Create Money Order</Button>} */}
                <CardContent>
                    <TabsWrapperStyle>
                        <Tabs
                            classes={{ indicator: 'indicator' }}
                            style={customStyles}
                            allowScrollButtonsMobile
                            variant="scrollable"
                            scrollButtons="auto"
                            value={currentTab}
                            onChange={changeTab}
                            // indicatorColor="secondary"
                            TabIndicatorProps={{
                                style: {
                                    //   display: 'none',
                                    paddingTop: 5,
                                    marginBottom: 15
                                }
                            }}
                        >
                            {TABS.map((tab) => (
                                <Tab disableRipple key={tab.value} value={tab.value} iconPosition='start' icon={tab.icon} label={capitalCase(tab.value)} />
                            ))}
                        </Tabs>
                    </TabsWrapperStyle>
                    {TABS.map((tab) => {
                        const isMatched = tab.value === currentTab;
                        return isMatched && <Box sx={{ mt: 2, backgroundColor: tab.injected ? '#eee' : '' }} key={tab.value}>{tab.component}</Box>;
                    })}


                </CardContent>
            </Card>
        </Page >
    )
}